import { ACCEPTED_CURRENCY_CODES } from "./constants";

export const normalizeCurrencyCode = (currencyCode: string): string =>
  currencyCode.trim().toUpperCase();

export const isAcceptedCurrency = (
  currencyCode: string,
  acceptedCurrencyCodes: readonly string[] = ACCEPTED_CURRENCY_CODES,
): boolean => {
  const normalizedCode = normalizeCurrencyCode(currencyCode);

  if (normalizedCode === "USD") {
    return true;
  }

  return acceptedCurrencyCodes
    .map(normalizeCurrencyCode)
    .includes(normalizedCode);
};

export const isDisplayOnlyCurrency = (
  currencyCode: string,
  acceptedCurrencyCodes: readonly string[] = ACCEPTED_CURRENCY_CODES,
): boolean => !isAcceptedCurrency(currencyCode, acceptedCurrencyCodes);

export const shouldShowDualPricing = (
  currencyCode: string,
  dualPricingEnabled: boolean,
  acceptedCurrencyCodes: readonly string[] = ACCEPTED_CURRENCY_CODES,
): boolean => {
  const normalizedCode = normalizeCurrencyCode(currencyCode);

  if (normalizedCode === "USD") {
    return false;
  }

  if (isDisplayOnlyCurrency(normalizedCode, acceptedCurrencyCodes)) {
    return true;
  }

  return dualPricingEnabled;
};
